












import Vue from 'vue';
import { mapActions } from 'vuex';
import UserMenuMobileSubMenuProfileLinksItem from '@/components/global/UserMenuMobile/UserMenuMobileSubMenu/UserMenuMobileSubMenuProfileLinks/UserMenuMobileSubMenuProfileLinksItem.vue';
import { IMenuItem } from './types';
import { LINK_TO_MOBILE_APP } from '~/constants/common';

const WAR_ROOM_PRODUCTS_ROUTE_NAME = 'war-room-products';
const PROFILE_SETTINGS_ROUTE_NAME = 'profile-settings';
const PERFORMANCE_INDEX_ROUTE_NAME = 'performance-index';
const ACADEMY_ROUTE_NAME = 'academy';

export default Vue.extend({
  name: 'UserMenuMobileSubMenuProfileLinks',
  components: {
    UserMenuMobileSubMenuProfileLinksItem,
  },
  computed: {
    menu(): IMenuItem[] {
      const items = [
        {
          name: 'Performance Index',
          icon: 'chart',
          to: { name: PERFORMANCE_INDEX_ROUTE_NAME },
        },
        {
          name: 'Academy',
          icon: 'book',
          to: { name: ACADEMY_ROUTE_NAME },
          onlyForAdmins: false,
        },
        {
          name: 'Commission Store',
          icon: 'shop',
          to: { name: WAR_ROOM_PRODUCTS_ROUTE_NAME },
        },
        {
          name: 'Salaries',
          icon: 'salaries',
          href: '/salaries/',
        },
        {
          name: 'Tech Sales U',
          icon: 'techsalesu',
          href: this.$auth.user?.xperiencifyMagicLoginLink,
        },
        {
          name: 'Settings',
          icon: 'settings',
          to: { name: PROFILE_SETTINGS_ROUTE_NAME },
        },
        {
          name: 'Get Bravado App',
          icon: 'apple',
          href: LINK_TO_MOBILE_APP,
        },
        {
          name: 'Sign Out',
          icon: 'sign-out',
          // @ts-ignore
          action: this.handleSignOut,
        },
      ];

      if (this.$auth.loggedIn && !this.$auth.user.xperiencifyMagicLoginLink) {
        if (!this.$auth.user.admin) {
          return items.filter(item => item.name !== 'Tech Sales U' && !item.onlyForAdmins);
        }
        return items.filter(item => item.name !== 'Tech Sales U');
      }
      if (!this.$auth.loggedIn || !this.$auth.user.admin) {
        return items.filter(item => !item.onlyForAdmins);
      }

      return items;
    },
  },
  methods: {
    ...mapActions(['signOut']),
    async handleSignOut(): Promise<void> {
      try {
        await this.signOut();
      } catch (e) {
        this.$notice.error(e);
      }
    },
    handleClick(item: IMenuItem) {
      this.$emit('on-menu-click');
      item.action && item.action();
    },
  },
});
